<img  *ngIf= "congratulationsutility?.status =='success'" src="https://infinity9.gotrackier.com/pixel?av=612df4c302535a0b13372bab" />
<section class="congrats-banner">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 col-md-12 col-xs-12">
                <div class="congrats-content">
                    <img *ngIf= "congratulationsutility?.status =='success' " src="assets/img/check-circle.png">
                    <img *ngIf=" congratulationsutility?.status =='fail'"  src="assets/img/white-cancel.svg">
                    <h1 *ngIf= "congratulationsutility?.status =='success' ">Congratulations!</h1>
                    <h1 *ngIf=" congratulationsutility?.status =='fail'">Payment Fails</h1>
                    <h6>Make your learning Infinite and <span class="label label-danger">fun</span></h6>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="user-sec">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 col-md-12 col-xs-12">
                <div class="user-content">
                    <div class="user-head">
                        <h1>Hi, {{congratulationsutility?.firstname || 'User'}} {{congratulationsutility?.lastname}}</h1>
                        <p *ngIf= "congratulationsutility?.status =='success'">Welcome to Infinity Learn ILITE!<br>
                        You have successfully enrolled to ILITE for {{selectedPkg.displayName}}</p>
                        <p *ngIf="congratulationsutility?.status =='fail'"> 
                            You have  enrollment is Failed</p>
                    </div>
                   
                </div>
            </div>
            <div class="col-lg-12 col-md-12 col-xs-12">
                <div class="display-center">
                    <div class="userschedule">
                        <div class="scheduleone">
                            <div class="">
                                <i class="fa fa-calendar-o" aria-hidden="true"></i>
                            </div>
                            <div>
                                <a href="javascript:void(0);">{{selectedPkg?.date}}</a>
                            </div>
                        </div>
                        <div class="scheduleone">
                            <div class="">
                                <i class="fa fa-clock-o" aria-hidden="true"></i>
                            </div>
                            <div>
                                <a href="javascript:void(0);">90 mins</a>
                            </div>
                        </div>
                        <div class="scheduleone">
                            <div class="">
                                <i class="fa fa-file-text-o" aria-hidden="true"></i>
                            </div>
                            <div>
                                <a href="javascript:void(0);">{{selectedPkg?.subjectsDisplayName}}</a>
                            </div>
                        </div>
                        <div class="scheduleone">
                            <div class="">
                                <i class="fa fa-pencil" aria-hidden="true"></i>
                            </div>
                            <div>
                                <a href="javascript:void(0);">Total of 90 questions</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- div class="learnbtncenter col-lg-12 col-md-12 col-xs-12">
                <a><button (click)='downloadInvoice()' *ngIf= "congratulationsutility?.status =='success' "  type="button" class="congrtas-startlearnbtn">Download Invoice</button></a>
            </div -->
            <div class="col-lg-12 col-md-12 col-xs-12">
                <div class="query-contact">
                    <h4>For more query,  we are available here</h4>
                    <ul class="congrats-contact">
                        <li><i class="fa fa-phone" aria-hidden="true"></i><a href="#">9019846666</a></li>
                        <li><i class="fa fa-globe" aria-hidden="true"></i><a href="#">info@infinitylearn.com</a></li>
                    </ul>
                </div>

                <div class="learnbtncenter">
                    <a><button (click)='navigateToDashboard()' type="button" class="congrtas-startlearnbtn">START LEARNING</button></a>
                </div>
            </div>
            
        </div>
    </div>
</section>